import * as actionTypes from '../actions/actionTypes';

import { updateObject }  from '../utility';

const initialstate = {
    baggageValue: null,
    baggageIndex: 0
}

const reducer = (state = initialstate, action) => {
    switch(action.type) {
        case actionTypes.SELECT_BAGGAGE:
            return updateObject(state, { baggageValue: action.val, baggageIndex: action.index })
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/baggage.js